import { RoleLevel } from "../users/users";

export enum PortalResultType {
  DDL = "DDL",
  GRID = "GRID",
}

export interface GetPortalQueryParams {
  languageCode: string;
}

export interface GetPortalsParams {
  portalName?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
  resultType: PortalResultType;
}

export interface Language {
  languageCode: string;
  isDefault?: boolean;
}

export interface ConnectedPortalSummary {
  portalId: number;
  portalUid: string;
  name: string;
}

export interface Portal {
  portalId: number;
  portalUid: string;
  name: string;
  url: string;
  urlName: string;
  authoringTool: boolean;
  customTranslation: boolean;
  spoofingEmail?: string;
  maxRoleLevel?: RoleLevel;
  isMain: boolean;
  portalLanguages: Language[];
  isSubportal: boolean;
  subPortals: Portal[];
  status?: string;
  parentPortal?: ConnectedPortalSummary | null;
  siblingPortals?: ConnectedPortalSummary[];
}

export interface PortalsResponse {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: Portal[];
}

export interface AddSubPortals {
  portalUid?: string;
  name: string;
  url?: string;
  urlName?: string;
  parentPortalUid?: string;
}

export interface CreatePortalBodyParams {
  name: string;
  url: string;
  urlName: string;
  authoringTool: boolean;
  customTranslation: boolean;
  maxRoleLevel?: RoleLevel;
  spoofEmail?: string;
  subPortals?: AddSubPortals[];
  portalLanguages: Language[];
  parentPortalUid?: string;
}

export interface UpdatePortalBodyParams {
  name?: string;
  url?: string;
  urlName?: string;
  authoringTool?: boolean;
  customTranslation?: boolean;
  maxRoleLevel?: RoleLevel;
  spoofEmail?: string;
  portalLanguages?: Language[];
}

export interface SetVisiblePagesParams {
  pageId: string;
  isVisible: boolean;
  user: string;
}

export interface UpdateAttribute {
  attributeKey: string;
  attributeValue: string;
}

export interface Attribute {
  portalDesignUid: string;
  portalUid: string;
  pageUid: string;
  pageSectionKey: string;
  attributeKey: string;
  attributeValue: string;
  isManual: boolean;
}

export interface Page {
  portalPageUid: string;
  path: string;
  name: string;
  isVisible: boolean;
}

export interface PortalPageVisibility {
  name: string;
  path: string;
  isVisible: boolean;
}
